import OrbitApiV1 from '.'

class AuthAPI {
  static getOtpByEmail(email, captchaToken) {
    // if(isDemo) --> get from indexedDB

    return OrbitApiV1.httpPost(`/auth/otp`, {}, { email, captchaToken })
  }

  static logUserIn(email, otp) {
    return OrbitApiV1.httpPost(`/auth/login`, {}, { email, otp })
  }

  static logUserOut() {
    return OrbitApiV1.httpPost(`/auth/logout`)
  }
}

export default AuthAPI
